"use client";
import NavRightDetail from "@/components/nav-right-detail";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import SaveReadingsChapter from "./save-readings-chapter";
import NextPrev from "@/components/next-prev";
import { FiBook } from "react-icons/fi";
import { TbPencilMinus } from "react-icons/tb";
import { AiOutlineClockCircle, AiOutlineHeart } from "react-icons/ai";
import { RiCharacterRecognitionLine } from "react-icons/ri";
import CustomLink from "@/components/custom-link";
import { BsArrowLeft, BsArrowRight } from "react-icons/bs";
import CommentStory from "@/modules/book-body/components/comment-story";
import { definitions } from "@/services/metruyenvl";
import { renderContentWithLineBreaks, unixToDate } from "@/utils/formatted";
import Image from "next/image";
import { getSettingUser, initSettingUser, userInfo } from "@/redux/reducers/user.reducer";
import { AppDispatch } from "@/redux/store";
import { setBannerConfig, setTheme, themeColor } from "@/redux/reducers/theme.reducer";
import bookAPI from "@/services/book_api";
import { authorInfo, getConfigBanner } from "@/redux/reducers/author.reducer";
import readAPI from "@/services/read_api";
import { useAuth } from "@/hooks";
import authAPI from "@/services/auth_api";
interface ICustomBgChapter {
    contentColor: string;
    bgColor: string;
    buttonColor: string;
}

export default function ChapterBodyStyles({ book, slug, chapter, chapterWords }: { book?: definitions["do.BookDO"]; chapterWords: number; slug: string; chapter: definitions["do.ChapterContentRes"] }) {
    const hoverBtnBgColor = "#99BC85";
    const dispatch = useDispatch<AppDispatch>();
    const customTheme = useSelector(themeColor);
    const bodyRef: any = useRef(null);
    const bannerStore = useSelector(authorInfo);
    const userReducer = useSelector(userInfo);
    const { isAuth } = useAuth();
    const getChapter = async () => {
        try {
            const res = await bookAPI.getDetailAndChapter(slug, chapter.slug ?? "");
            if (isAuth) {
                const read = await readAPI.createRead(book?.id ?? "", chapter.id ?? "");
            }
        } catch (error) {
            console.log(error);
        }
    };
    useEffect(() => {
        const getBannerConfig = async () => {
            try {
                const res = await authAPI.getBanner();
                dispatch(setBannerConfig(res.data?.[0]));
            } catch (error) {
                console.log(error);
            }
        };
        getBannerConfig();
    }, []);
    useEffect(() => {
        getChapter();
        if (isAuth) {
            dispatch(getSettingUser());
        } else {
            dispatch(initSettingUser());
        }
        dispatch(getConfigBanner());
        let customTheme: ICustomBgChapter = JSON.parse(localStorage.getItem("themeChapter") ?? "{}");
        if (customTheme.contentColor) {
            dispatch(setTheme(customTheme));
        } else {
            dispatch(
                setTheme({
                    bgColor: "#E1F0DA",
                    contentColor: "#D4E7C5",
                })
            );
        }
    }, [chapter]);
    const scrollToBottom = () => {
        window.scrollTo({
            top: bodyRef.current.offsetTop - 500,
            behavior: "smooth",
        });
    };
    return (
        <div className="w-full pt-5 lg:pl-[20%] lg:pr-[20%] md:pt-5 md:pb-5" style={{ background: customTheme.bgColor, borderTop: "solid 0.5px rgb(231 229 228)" }}>
            <SaveReadingsChapter book={book as definitions["do.BookDO"]} chapter={chapter as definitions["do.ChapterContentRes"]} />
            <a href={customTheme.bannerImage?.direct_url}>
                <Image unoptimized={true} src={customTheme.bannerImage?.image ?? "https://static.cdnno.com/storage/topbox/f4eb3cd0abfec7a6f34c12769eef54b7.jpg"} alt="" className="md:h-auto w-full h-36 md:w-full object-cover mb-0 md:mb-6" width={100} height={100} />{" "}
            </a>
            <div className="hidden p-6 mt-[-24px] lg:sticky md:mr-[-115px] md:flex w-fit z-[30] float-right">
                <NavRightDetail scrollComment={scrollToBottom} book={book as definitions["do.BookDO"]} chapter={chapter as definitions["do.ChapterContentRes"]} bgColor={customTheme.contentColor} />
            </div>

            <div id="chapterContent" className="w-full lg:rounded-xl p-6 mt-0" style={{ backgroundColor: customTheme.contentColor }}>
                <NextPrev bookSlug={slug} prevChapterSlug={chapter?.pre_chapter as string} nextChapterSlug={chapter?.next_chapter as string} backgroundColor={customTheme.buttonColor} hoverBgColor={hoverBtnBgColor} />
                <h1 className="mb-1 text-black font-semibold text-2xl mt-8">{chapter?.title}</h1>
                <div className="flex md:flex-row flex-col md:items-center gap-y-2 gap-x-4 pb-5">
                    <a className="flex items-center gap-x-1 cursor-pointer" href={`/truyen/${book?.slug}`}>
                        <FiBook color="rgb(71 85 105)" />
                        <h2 className="text-slate-600 text-sm">{book?.name}</h2>
                    </a>
                    <a className="flex items-center gap-x-1 cursor-pointer" href={`/tac-gia/${book?.author?.slug}`}>
                        <TbPencilMinus color="rgb(71 85 105)" />
                        <h2 className="text-slate-600 text-sm">{book?.author?.name}</h2>
                    </a>
                    <div className="flex items-center gap-x-1 cursor-pointer">
                        <AiOutlineHeart color="rgb(71 85 105)" />
                        <p className="text-slate-600 text-sm">33 lượt thích</p>
                    </div>
                    {chapterWords ? (
                        <div className="flex items-center gap-x-1 cursor-pointer">
                            <RiCharacterRecognitionLine color="rgb(71 85 105)" />
                            <p className="text-slate-600 text-sm">{chapterWords} chữ</p>
                        </div>
                    ) : (
                        ""
                    )}

                    <div className="flex items-center gap-x-1">
                        <AiOutlineClockCircle color="rgb(71 85 105)" />
                        <p className="text-slate-600 text-sm">{unixToDate(chapter?.updated_time as number)}</p>
                    </div>
                </div>
                <div
                    dangerouslySetInnerHTML={{ __html: renderContentWithLineBreaks(chapter?.content) }}
                    className="w-full"
                    style={{
                        fontSize: userReducer.userSettings.font_size ?? 16,
                        fontFamily: userReducer.userSettings.font_family ?? "normal",
                        letterSpacing: userReducer.userSettings.space_column ?? 0,
                    }}
                />
            </div>
            <div ref={bodyRef} className="w-full rounded-xl grid grid-cols-2 items-center font-semibold justify-between mt-3 mb-5 pt-4 pb-4" style={{ backgroundColor: customTheme.contentColor }}>
                {chapter?.pre_chapter ? (
                    <CustomLink href={`/truyen/${slug}/${chapter?.pre_chapter}`} className="flex items-center justify-center gap-x-2 border-r border-solid border-black">
                        <BsArrowLeft /> Chương trước
                    </CustomLink>
                ) : (
                    <div className="flex items-center justify-center text-gray-200 gap-x-2 border-r border-solid border-black">
                        <BsArrowLeft /> Chương trước
                    </div>
                )}
                {chapter?.next_chapter ? (
                    <CustomLink href={`/truyen/${slug}/${chapter?.next_chapter}`} className="flex items-center justify-center gap-x-2 border-l border-solid border-black">
                        Chương sau <BsArrowRight />
                    </CustomLink>
                ) : (
                    <div className="flex items-center justify-center text-gray-200 gap-x-2">
                        Chương sau <BsArrowRight />
                    </div>
                )}
            </div>
            <div className="pr-3 pl-3">
                <CommentStory book={book as definitions["do.BookDO"]} chapter={chapter} />
            </div>
        </div>
    );
}
